import {RestrictedRouteModuleConfiguration} from "../router/model/UserPermission";
import {AngularJsMaterialModuleName, MainServiceModuleName} from "../utils/names/requiredModulesNames";
import 'angular-ui-bootstrap';

export const MainServiceModule = new RestrictedRouteModuleConfiguration(MainServiceModuleName,
    [
        AngularJsMaterialModuleName
    ],
    [],
    [],
    [],
    []
);